import React from "react";
import ButtonBase from "@material-ui/core/Button";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  LinearProgress,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  useTheme,
  IconButton,
  Button,
  DialogActions,
  FormControlLabel,
  Checkbox,
} from "@material-ui/core";
import MuiTable from "@material-ui/core/Table";
import { useProcedureResultView } from "../testCommunication/common/testQueries";
import {
  useAddNoteToResult,
  useRetestProcedure,
  useReviewProcedure,
  useUpdateFlag,
} from "./dataEgressMutations";
import { ErrorMessage } from "../common/ErrorMessage";
import { ThreadedCreator } from "../common/threadedViewer/threadedCreator";
import { useDefaultColumn, generalFilter } from "../../util/filter";
import { useTable, useFilters, useSortBy } from "react-table";
import CloseIcon from "@material-ui/icons/Close";
import { useView } from "./dataEgressQueries";
import CachedIcon from "@material-ui/icons/Cached";
import {
  useTestPermissions,
  useTestPermissionsVerification,
} from "../projectManagement/projectQueries";
import { ConfirmationDialog } from "../common/ConfirmationDialog";
import { useFetchContext } from "../common/FetchContext";
import { toast } from "react-toastify";
import { useQueryClient } from "react-query";
import { processErrorOnMutation } from "../../util/errorMessaging";
import { useAuthContext } from "../common/AuthContext";
import { useHistory } from "react-router-dom";
import { TravelerModalButton } from "./TravelerModalButton";
import { VisualizerNotesModal } from "./VisualizerNotesModal";
import { LSDBCoreTable } from "../common/LSDBCoreTable";
import { StepResultNotes } from "../projectManagement/components/virtualTraveler/StepResultNotes";
import { formatDate } from "../common/formatDate";
import { getTheme } from "../common/getLocalTheme";

export const PanIamModel = ({
  id,
  name,
  disposition,
  dispositionPassedId,
  open_notes,
  has_notes,
   isComments,
  onOpenNotes,
}: {
  id: any;
  name: any;
  disposition: any;
  dispositionPassedId?: any;
  open_notes: any;
  has_notes: any;
    isComments?:any;
  onOpenNotes?:any;
}) => {
  const history = useHistory();
  const { mutateAsync: mutateRetestProcedure } = useRetestProcedure();
  const { mutateAsync: mutateReviewProcedure } = useReviewProcedure();
  const { authAxios } = useFetchContext();
  const queryClient = useQueryClient();
  const { dispatch } = useAuthContext();

  const [isOpen, setIsOpen] = React.useState<boolean>(false);
  const [procedureResultData, setProcedureResultData] = React.useState([]);
  const [confirmationDialogRetestOpen, setConfirmationDialogRetestOpen] =
    React.useState(false);
  const [confirmationDialogApproveOpen, setConfirmationDialogApproveOpen] =
    React.useState(false);
  const theme = useTheme();
  const defaultColumn = useDefaultColumn();
  const { mutateAsync: mutateNote } = useAddNoteToResult();
  const NOT_AVAILABLE = "N/A";

  const [flagChecked, setFlagCheck] = React.useState(false);
  const [flagDialog, setFlagDialog] = React.useState(false)
  const { mutateAsync: mutateUpdateFlag } = useUpdateFlag();
  const submitFlagUpdate = async () => {
    try {

      if (flagChecked) {
        await mutateUpdateFlag({
          authAxios,
          id:procedureData.id,
          final_result: false
        });
        setFlagCheck(false)
      } else {
        await mutateUpdateFlag({
          authAxios,
          id:procedureData.id,
          final_result: true
        });
        setFlagCheck(true)
      }
      toast.success("Request Submited Successfully");
      setFlagDialog(false)
      queryClient.invalidateQueries("travelerResults");


    } catch (error) {
      toast.error("Request Submition Failed");
      setFlagDialog(false)
    }

  };

  const {
    data: procedureData,
    error: procedureError,
    isLoading: isLoadingProcedure,
    isError: isErrorProcedure,
    isSuccess: isSuccessProcedure,
  } = useView(id, isOpen);




  const { data: permission, isLoading: isLoadingPermission } =
    useTestPermissionsVerification(id, isOpen);

  React.useEffect(() => {
    if (isSuccessProcedure) {
      procedureData.final_result?setFlagCheck(true):setFlagCheck(false)
      setProcedureResultData(procedureData.step_results);
    }
  }, [isSuccessProcedure, procedureData]);



  if (isLoadingProcedure || isLoadingPermission) {
    return (
      <div style={theme.containerMargin}>
        <Grid>
          <Grid item xs={12}>
            <LinearProgress />
          </Grid>
        </Grid>
      </div>
    );
  }

  if (isErrorProcedure) {
    return <ErrorMessage error={procedureError} />;
  }

  const toggleOpenState = () => {
    setIsOpen((value) => !value);
  };


  const submitVerification = async (result: boolean) => {
    if (result) {
      try {
        await mutateReviewProcedure({
          authAxios,
          disposition: dispositionPassedId,
          procedure_result: procedureData.id,
        });
        toast.success(" Review Approved");
        setConfirmationDialogApproveOpen(false);
        setIsOpen(false);
        queryClient.invalidateQueries("verify_data");
        queryClient.invalidateQueries("travelerResults");
      } catch (error) {
        toast.error("Error while approving Test");
        processErrorOnMutation(error, dispatch, history);
        setConfirmationDialogApproveOpen(false);
        setIsOpen(false);
        queryClient.invalidateQueries("verify_data");
        queryClient.invalidateQueries("travelerResults");
      }
    } else {
      try {
        await mutateRetestProcedure({
          authAxios,
          procedure_result: procedureData.id,
        });
        toast.success("Test Review was sent for retesting");
        setConfirmationDialogRetestOpen(false);
        setIsOpen(false);
        queryClient.invalidateQueries("verify_data");
        queryClient.invalidateQueries("travelerResults");
      } catch (error) {
        toast.error("Error while retesting Test");
        processErrorOnMutation(error, dispatch, history);
        setConfirmationDialogRetestOpen(false);
        setIsOpen(false);
        queryClient.invalidateQueries("verify_data");
        queryClient.invalidateQueries("travelerResults");
      }
    }
  };

  return (
    <React.Fragment>
      <TravelerModalButton
        disposition={disposition}
        name={name}
        handleClose={toggleOpenState}
        open_notes={open_notes}
        has_notes={has_notes}
        type="pan"
         isComments={isComments}
        onOpenNotes={onOpenNotes}
      />
      <Dialog open={isOpen} onClose={toggleOpenState} fullWidth maxWidth="lg">
        <DialogTitle id="scroll-dialog-title">
          <Grid
            container
            direction="row"
            justify="space-between"
            alignItems="center"
            spacing={2}
          >
            <Grid item xs={8}>
              <Typography variant="h6">{`${name}`};</Typography>
            </Grid>
            <Grid item xs={1}>
              <Typography variant="body2" display="inline">
                Flag Result:
              </Typography>
            </Grid>
            <Grid item xs={1}>
              <ThreadedCreator
                id={id}
                noteType={3}
                model={"procedure"}
                invalidate={[""]}
                typeable={false}
              />
            </Grid>
            <Grid item xs={1}>
              <VisualizerNotesModal
                procedureId={id}
                name={`Stress Data Review - ${name}`}
              />
            </Grid>
            <Grid item xs={1}>
              <IconButton onClick={toggleOpenState}>
                <CloseIcon />
              </IconButton>
            </Grid>
          </Grid>
        </DialogTitle>
       <DialogContent dividers={true}>
          {procedureData?.supersede && (
            <Typography variant="body2" align="center">
              SUPERSEDED
            </Typography>
          )}
          <Grid container spacing={2}>

            <Grid item xs={8}>
              <Typography variant="body1">
                Heading: {procedureData?.procedure_definition_name || "N/A"}
              </Typography>
              <Typography variant="body1">
                Disposition: {procedureData?.disposition_name || "N/A"}
              </Typography>
              <Typography variant="body1">
                Start Date/Time: {formatDate(procedureData?.start_datetime) || NOT_AVAILABLE}
              </Typography>
              <Typography variant="body1">
                End Date/Time: {formatDate(procedureData?.end_datetime) || NOT_AVAILABLE}
              </Typography>
            </Grid>


            <Grid
              item
              xs={4}
              style={{
                marginBottom: "20px",
                padding: "12px",
                
              }}
            >
              <Typography variant="body1">
                Asset Name: {procedureData?.assets?.[0] || "N/A"}
              </Typography>
              <Typography variant="body1">
                Last Calibration Date:{" "}
                {procedureData?.last_calibration_date?.[0]
                  ? procedureData.last_calibration_date[0].substring(0, 10)
                  : "N/A"}
              </Typography>

              
            </Grid>
          </Grid>

          {permission && (
            <Grid container justifyContent="flex-end" spacing={2} style={{ marginTop: 16 }}>
              <Grid item>
                <Button
                  variant="contained"
                  style={theme.btnError}
                  disabled={getTheme()}
                  onClick={() => setConfirmationDialogRetestOpen(true)}
                >
                  Retest
                </Button>
              </Grid>
              {disposition === "Requires Review" && (
                <Grid item>
                  <Button
                    variant="contained"
                    style={theme.btnNew}
                    onClick={() => setConfirmationDialogApproveOpen(true)}
                  >
                    Approve
                  </Button>
                </Grid>
              )}
            </Grid>
          )}
        </DialogContent>
        <DialogActions>
          <Grid
            container
            direction="row"
            justify="space-between"
            alignItems="center"
            spacing={2}
          >
            <Grid item xs={1} />

            <Grid item xs={10} alignItems="center">
              <FormControlLabel
                control={
                  <Checkbox
                    checked={flagChecked}
                    onChange={() => {
                      setFlagDialog(true)
                    }}
                    name="autoCheck"
                    color="primary"
                    disabled = {getTheme()}
                  />
                }
                label="Final Result"
              />
            </Grid>

          </Grid>


        </DialogActions>
        <ConfirmationDialog
          id="stress-review-retest"
          keepMounted
          open={confirmationDialogRetestOpen}
          title=" Review Retest Confirmation"
          content="Are you sure that you want to retest this Review?"
          onCancel={() => setConfirmationDialogRetestOpen(false)}
          onSubmit={() => submitVerification(false)}
        />
        <ConfirmationDialog
          id="stress-review-approve"
          keepMounted
          open={confirmationDialogApproveOpen}
          title=" Review Approval Confirmation"
          content="Are you sure that you want to approve this Review?"
          onCancel={() => setConfirmationDialogApproveOpen(false)}
          onSubmit={() => submitVerification(true)}
        />

        <ConfirmationDialog
          id="flag-update"
          keepMounted
          open={flagDialog}
          title="Approval Confirmation"
          content="Please confirm whether the selected result is Correct?"
          onCancel={() => setFlagDialog(false)}
          onSubmit={() => submitFlagUpdate()}
        />
      </Dialog>
    </React.Fragment>
  );
};
